import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import { emailValidation, errorResponseMessage } from "./const.prop";
import ErrorMessage from "../components/ErrorMessage";
import axiosHttp from "../config/axios.interceptor";
import { AuthContext } from "../contexts/AuthContext";

const ForgetPassword = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });
  const submitHandler = async (data) => {
    try {
      appContext.updateLoaderState(true);
      const emailSendHandler = await axiosHttp.post(`forget-password`, {
        email: data.email,
      });
      if (emailSendHandler.status === 201) {
        appContext.updateModalState();
        localStorage.setItem("userId", emailSendHandler.data.userId);
        // setTimeout(() => {
        appContext.updateModalType("forgetOTP");
        appContext.updateLoaderState(false);
        // }, 200);
      } else {
        appContext.updateLoaderState(false);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(e);
      appContext.updateLoaderState(false);
    }
  };
  return (
    <div className="modal-body px-5">
      <p className="modal-head">
        <a
          onClick={(e) => {
            e.preventDefault();
            appContext.updateModalState();
          }}
          className="arrow mr-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect width="24" height="24" rx="4" fill="#F7F7F7" />
            <path
              d="M10.7384 17.7432L5.22953 12.0942C5.14607 12.0086 5.08681 11.9159 5.05175 11.816C5.01725 11.7162 5 11.6092 5 11.4951C5 11.3809 5.01725 11.274 5.05175 11.1741C5.08681 11.0742 5.14607 10.9815 5.22953 10.8959L10.7384 5.2469C10.8914 5.08998 11.0825 5.00781 11.3118 5.0004C11.5416 4.99355 11.74 5.07572 11.9069 5.2469C12.0738 5.40382 12.1609 5.59982 12.1682 5.83491C12.1748 6.07057 12.0947 6.27399 11.9278 6.44518L7.83788 10.6391H17.1653C17.4018 10.6391 17.6002 10.721 17.7604 10.8848C17.9201 11.0491 18 11.2526 18 11.4951C18 11.7376 17.9201 11.9407 17.7604 12.1045C17.6002 12.2688 17.4018 12.351 17.1653 12.351H7.83788L11.9278 16.5449C12.0808 16.7019 12.1609 16.9016 12.1682 17.1441C12.1748 17.3866 12.0947 17.5863 11.9278 17.7432C11.7747 17.9144 11.58 18 11.3435 18C11.107 18 10.9053 17.9144 10.7384 17.7432Z"
              fill="#565555"
            />
          </svg>
        </a>
        Forgot Password
      </p>
      {/* <p>Enter your email address.</p> */}
      <form onSubmit={handleSubmit(submitHandler)}>
        <div className="mb-3 mt-4">
          <label className="sign-label">Email address</label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text sign-icon" id="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M13.3929 1.875H1.60715C1.01542 1.875 0.535721 2.35469 0.535721 2.94643V12.0536C0.535721 12.6453 1.01542 13.125 1.60715 13.125H13.3929C13.9846 13.125 14.4643 12.6453 14.4643 12.0536V2.94643C14.4643 2.35469 13.9846 1.875 13.3929 1.875Z"
                    stroke="black"
                    strokeOpacity="0.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M0.535721 3.21428L6.81429 8.57142C7.00681 8.73178 7.24945 8.81959 7.50001 8.81959C7.75056 8.81959 7.9932 8.73178 8.18572 8.57142L14.4643 3.21428"
                    stroke="black"
                    strokeOpacity="0.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
            <input
              type="text"
              className="form-control sign-form "
              {...register("email", emailValidation)}
            />
            <ErrorMessage errors={errors} errorKey="email" />
          </div>
          <div className="row mt-5">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <button
                onClick={appContext.updateModalState}
                className="btn btn-outline-secondary  modal-btn "
                style={{ borderRadius: "32px" }}
              >
                Cancel
              </button>
            </div>
            <div className="col-md-4">
              <button
                type="submit"
                className="btn btn-primary sign-btn con"
                disabled={appContext.loaderState}
              >
                Continue
              </button>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ForgetPassword;
